import axiosInstance from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import NotifTransformer from './transformers/notification-transformer'
import { ApiResponse } from '@/types'

export const getFlashMessages = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const response = await axiosInstance().get('/flash-messages')

    if (response.data && response.data != []) {
      resp.data = NotifTransformer.flashMessageToNotification(response.data)
    } else {
      resp.data = null
    }
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }

  return resp
}
